import { render } from "./NewsroomPage.vue?vue&type=template&id=1bc5ff95"
import script from "./NewsroomPage.vue?vue&type=script&lang=js"
export * from "./NewsroomPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__